// BetProtect — Milestone Badges & Gamification

export interface Milestone {
  id: string;
  title: string;
  description: string;
  emoji: string;
  color: string;
  bgColor: string;
  borderColor: string;
  check: (stats: MilestoneStats) => boolean;
  progress: (stats: MilestoneStats) => { current: number; target: number };
}

export interface MilestoneStats {
  streakDays: number;
  exercisesDone: number;
  totalCheckIns: number;
  moodConsistencyDays: number; // days with mood logged in last 7
  avgMood7d: number;
}

export const MILESTONES: Milestone[] = [
  {
    id: 'streak-14',
    title: '14-Day Warrior',
    description: 'Maintain a 14-day check-in streak',
    emoji: '🔥',
    color: '#f97316',
    bgColor: 'rgba(249,115,22,0.12)',
    borderColor: 'rgba(249,115,22,0.3)',
    check: (s) => s.streakDays >= 14,
    progress: (s) => ({ current: Math.min(s.streakDays, 14), target: 14 }),
  },
  {
    id: 'exercises-10',
    title: 'Coping Champion',
    description: 'Complete 10 coping exercises',
    emoji: '🏆',
    color: '#8b5cf6',
    bgColor: 'rgba(139,92,246,0.12)',
    borderColor: 'rgba(139,92,246,0.3)',
    check: (s) => s.exercisesDone >= 10,
    progress: (s) => ({ current: Math.min(s.exercisesDone, 10), target: 10 }),
  },
  {
    id: 'mood-consistency',
    title: 'Mood Tracker',
    description: 'Log your mood 7 days in a row',
    emoji: '😊',
    color: '#22c55e',
    bgColor: 'rgba(34,197,94,0.12)',
    borderColor: 'rgba(34,197,94,0.3)',
    check: (s) => s.moodConsistencyDays >= 7,
    progress: (s) => ({ current: Math.min(s.moodConsistencyDays, 7), target: 7 }),
  },
];

export function computeMilestoneStats(profile: {
  streakDays: number;
  exercisesDone: number;
  totalCheckIns: number;
}): MilestoneStats {
  return {
    streakDays: profile.streakDays,
    exercisesDone: profile.exercisesDone,
    totalCheckIns: profile.totalCheckIns,
    // Approximate mood consistency from streak (if streak >= 7, user has been consistent)
    moodConsistencyDays: Math.min(profile.streakDays, 7),
    avgMood7d: 0,
  };
}

export function getEarnedMilestones(stats: MilestoneStats): Milestone[] {
  return MILESTONES.filter((m) => m.check(stats));
}

export function getPendingMilestones(stats: MilestoneStats): Milestone[] {
  return MILESTONES.filter((m) => !m.check(stats));
}
